import React from 'react';

import { useTranslation } from 'react-i18next';
import Paragraph from '../../uiKit/typography/paragraph';


export default React.memo(function WhyEpicBlock({
                                                children, slideWidth = 260, speed = 10,
                                                className = '', containerClassName = '',
                                                direction = 'left'
                                              }) {
  const { t } = useTranslation('common');

  const cardsData = [{
    title: 'cards.titles.why_epic_experiences',
    description: 'cards.descriptions.why_epic_experiences'
  },
    {
      title: 'cards.titles.why_epic_execution',
      description: 'cards.descriptions.why_epic_execution'
    },
    {
      title: 'cards.titles.why_epic_delivery',
      description: 'cards.descriptions.why_epic_delivery'
    },
    {

      title: 'cards.titles.why_epic_integration',
      description: 'cards.descriptions.why_epic_integration'
    }]


  return (<>
      <Paragraph className={'text-center text-black text-3xl mb-8'}>
        {t('titles.why_epic')}
      </Paragraph>
      <div className={'flex w-full grid grid-cols-1 sm:grid-cols-2 gap-8'}>
        {cardsData.map((card,index) => (<div key={index}
                                            className="w-full gap-4 p-10 bg-white border border-gray-200 rounded-[10px]">
            <h6 className="mb-1 text-2xl font-medium text-black">{t(card.title)}</h6>
            <p className="text-black/70 ">{t(card.description)}</p>
          </div>)
        )}
      </div>

    </>

  )
})
